import { css } from '@emotion/react';
import { AnimatePresence, motion, Variants } from 'motion/react';
import { ColumnEntityReorderStoreProvider } from '../../components/calendar-view/providers';
import { useIsScheduleSmallModeWindow } from '../../hooks/use-schedule-small-mode';
import { useSyncCalendarLocation } from '../../stores/calendar-location.store';
import { CalendarProvider } from '../../stores/calendar.store';
import { SchedulePulseTrayContent } from '../schedule-pulse-panel';
import { CalendarV3Container } from './CalendarV3Container';
import { ScheduleOnboardingFlow } from './onboarding-flow';

const CalendarV3Component = () => {
  const { isSmallModeWindow } = useIsScheduleSmallModeWindow();

  useSyncCalendarLocation();

  const fadeVariants: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <>
      <AnimatePresence mode='wait'>
        {isSmallModeWindow ? (
          <motion.div
            key='list-view'
            variants={fadeVariants}
            initial='initial'
            animate='animate'
            exit='exit'
            css={containerStyle}
          >
            <SchedulePulseTrayContent isSmallModeWindow />
          </motion.div>
        ) : (
          <motion.div
            key='calendar-view'
            variants={fadeVariants}
            initial='initial'
            animate='animate'
            exit='exit'
            css={containerStyle}
          >
            <ColumnEntityReorderStoreProvider>
              <CalendarV3Container />
            </ColumnEntityReorderStoreProvider>
          </motion.div>
        )}
      </AnimatePresence>
      <ScheduleOnboardingFlow />
    </>
  );
};

export const CalendarV3 = () => (
  <CalendarProvider>
    <CalendarV3Component />
  </CalendarProvider>
);

const containerStyle = css({
  height: '100%',
});
